import { createApp } from 'vue'
import mitt from 'mitt';
//import { provide } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import { getApiBaseUrl, setupApiInterceptors } from './api/client';

import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './registerServiceWorker'
import { getEnvironmentLabel } from './config/appConfig'

loadFonts()

const isIgnoredResizeObserverError = (message) =>
  typeof message === 'string' &&
  message.includes('ResizeObserver loop completed with undelivered notifications')

window.addEventListener('error', (event) => {
  if (!isIgnoredResizeObserverError(event?.message)) return

  event.stopImmediatePropagation()
  event.preventDefault()
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const message = event?.reason?.message || event?.reason || ''
  if (!isIgnoredResizeObserverError(message)) return

  event.stopImmediatePropagation()
  event.preventDefault()
}, true)

console.log('environment:', getEnvironmentLabel())
console.log('api baseURL:', getApiBaseUrl())

//Redirect User to login after ACCESS_TOKEN_EXPIRE_MINUTES = 30 Minuten
setupApiInterceptors({ store, router });

const emitter = mitt();

async function bootstrap() {
  if (store.restored) {
    await store.restored
  }

  await store.dispatch('initializeAuth')

  const vm = createApp(App)
  vm.use(vuetify)
  vm.use(router)
  vm.use(store)
  vm.config.globalProperties.emitter = emitter
  vm.mount('#app')

  console.log('Started',vm)
}

bootstrap()


// we need to provide it to the app to be used globally
//provide('eventBus', eventBus)
// vm.provide('eventBus',eventBus);


